import React, { useEffect, useState, useRef } from "react";
import {
  getCategories,
  getSubCategories,
  getPriceRange,
  fetchFilteredProducts,
} from "../services/nonAuthRequets";
import ProductCards from "./ProductCards";
import PaginateComponent from "./PaginateComponent";
import NoResultsComponent from "./NoResultsComponent";
import LoadingComponent from "./LoadingComponent";
const ProductListTwo = () => {
  const [selectedPredefinedRange, setSelectedPredefinedRange] = useState(null);
  const [customMin, setCustomMin] = useState("");
  const [customMax, setCustomMax] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(500);
  const [isInitialized, setIsInitialized] = useState(false);
  const [selectedSubCategories, setSelectedSubCategories] = useState(new Set());
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState({});
  const [expandedCategories, setExpandedCategories] = useState(new Set());
  const [sortOption, setSortOption] = useState("newArrivals");
  const sidebarRef = useRef(null);
  const productsRef = useRef(null);

  const predefinedRanges = {
    range1: [minPrice, 1000],
    range2: [1000, 2500],
    range3: [2500, 5000],
    range4: [5000, maxPrice],
  };

  const getPriceFilter = () => {
    let low, high;
    if (selectedPredefinedRange === "custom") {
      low = customMin ? parseFloat(customMin) : minPrice;
      high = customMax ? parseFloat(customMax) : maxPrice;
    } else if (
      selectedPredefinedRange &&
      predefinedRanges[selectedPredefinedRange]
    ) {
      [low, high] = predefinedRanges[selectedPredefinedRange];
    } else {
      low = minPrice;
      high = maxPrice;
    }
    return [low, high];
  };

  const isCustomValid =
    customMin !== "" &&
    customMax !== "" &&
    parseFloat(customMin) < parseFloat(customMax);

  const handlePredefinedChange = (e) => {
    setSelectedPredefinedRange(e.target.value);
  };

  const handleCustomMinChange = (e) => {
    setCustomMin(e.target.value);
  };

  const handleCustomMaxChange = (e) => {
    setCustomMax(e.target.value);
  };

  const handleSortChange = (e) => {
    const newSortOption = e.target.value;
    setSortOption(newSortOption);
    // Reset other filter options when sort changes.
    setSelectedPredefinedRange(null);
    setCustomMin("");
    setCustomMax("");
    setSelectedSubCategories(new Set());
    setCurrentPage(0);
    // Fetch products with default price filter and new sort option.
    //fetchProducts(0, minPrice, maxPrice, []);
  };

  const fetchProducts = async (page, low, high, selectedCategories = []) => {
    setLoading(true);
    try {
      const response = await fetchFilteredProducts(
        page,
        18,
        low,
        high,
        selectedCategories,
        sortOption // Pass the current sort option
      );
      setTotalPages(response.totalPages);
      // setProducts((prevProducts) => {
      //   const updatedProducts = [...prevProducts, ...response.content];
      //   return Array.from(
      //     new Map(updatedProducts.map((p) => [p.id, p])).values()
      //   );
      // });
      setProducts(response.content);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategoriesData = async () => {
    try {
      const response = await getCategories();
      setCategories(response.content);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubCategoriesData = async (categoryId) => {
    try {
      if (!subCategories[categoryId]) {
        const response = await getSubCategories(categoryId);
        setSubCategories((prev) => ({ ...prev, [categoryId]: response }));
      }
    } catch (error) {
      console.error("Error fetching sub-categories:", error);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        const data = await getPriceRange();
        setMinPrice(data.minPrice);
        setMaxPrice(data.maxPrice);
        await fetchProducts(0, data.minPrice, data.maxPrice);
        setIsInitialized(true);
      } catch (error) {
        console.error("Error fetching price range:", error);
      }
    };
    init();
    fetchCategoriesData();
  }, []);

  // useEffect(() => {
  //   const delayFetch = setTimeout(() => {
  //     if (currentPage !== 0) {
  //       setCurrentPage(0);
  //     }
  //     const [low, high] = getPriceFilter();
  //     fetchProducts(0, low, high, [...selectedSubCategories]);
  //   }, 500);

  //   return () => clearTimeout(delayFetch);
  // }, [
  //   selectedPredefinedRange,
  //   customMin,
  //   customMax,
  //   selectedSubCategories,
  //   minPrice,
  //   maxPrice,
  //   sortOption,
  // ]);

  const toggleCategory = (categoryId) => {
    setExpandedCategories((prev) => {
      const newExpanded = new Set(prev);
      if (newExpanded.has(categoryId)) {
        newExpanded.delete(categoryId);
      } else {
        newExpanded.add(categoryId);
        fetchSubCategoriesData(categoryId);
      }
      return newExpanded;
    });
  };

  const handleCheckboxChange = (subCategoryId) => {
    setSelectedSubCategories((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(subCategoryId)) {
        newSet.delete(subCategoryId);
      } else {
        newSet.add(subCategoryId);
      }
      return newSet;
    });
  };
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  // const loadMoreProducts = () => {
  //   const nextPage = currentPage + 1;
  //   setCurrentPage(nextPage);
  //   const [low, high] = getPriceFilter();
  //   fetchProducts(nextPage, low, high, [...selectedSubCategories]);
  // };
  // useEffect(() => {
  //   const [low, high] = getPriceFilter();
  //   fetchProducts(currentPage, low, high, [...selectedSubCategories]);
  // }, [currentPage]);

  useEffect(() => {
    if (!isInitialized) return;
    if (selectedPredefinedRange === "custom") {
      // Don’t fetch until user clicks Apply
      return;
    }
    const delayFetch = setTimeout(() => {
      const [low, high] = getPriceFilter();
      fetchProducts(currentPage, low, high, [...selectedSubCategories]);
    }, 500);

    return () => clearTimeout(delayFetch);
  }, [
    currentPage,
    selectedPredefinedRange,
    //customMin,
    // customMax,
    selectedSubCategories,
    minPrice,
    maxPrice,
    sortOption,
  ]);

  const resetFilters = () => {
    setSelectedPredefinedRange(null);
    setCustomMin("");
    setCustomMax("");
    setSelectedSubCategories(new Set());
    setSortOption("newArrivals");
    setExpandedCategories(new Set());
    setSubCategories({});
    setCurrentPage(0);
  };
  const applyCustomPriceFilter = () => {
    // Reset to first page
    setCurrentPage(0);

    // Compute the low/high from the inputs (fallback to min/max)
    const low = customMin ? parseFloat(customMin) : minPrice;
    const high = customMax ? parseFloat(customMax) : maxPrice;

    // Trigger the fetch with the custom range and any selected categories
    fetchProducts(0, low, high, [...selectedSubCategories]);
  };

  useEffect(() => {
    if (!sidebarRef.current || !productsRef.current) return;
    const sidebarTop = sidebarRef.current.getBoundingClientRect().top;
    const productsBottom = productsRef.current.getBoundingClientRect().bottom;
    const maxHeight = productsBottom - sidebarTop;
    sidebarRef.current.style.maxHeight = `${maxHeight}px`;
    sidebarRef.current.style.overflowY = "auto"; // ensure scroll  :contentReference[oaicite:8]{index=8}
  }, [expandedCategories, currentPage, products.length]);

  //if (loading) return <p>Loading products...</p>;

  // The products are now sorted on the server side.
  const sortedProducts = products;
  {
    !loading && products.length === 0 && (
      <NoResultsComponent message="No products found for the selected filters." />
    );
  }
  return (
    <div className="row">
      <div className="col-md-3 mt-24">
        {/* Sidebar with filters and categories */}
        <div className="p-5 border rounded-lg shadow-md bg-white">
          <div className="p-3">
            <span className="mb-3 text-md fw-md text-black">
              Filter by Price
            </span>
            <ul className="list-group checked-bigmall">
              {/* Price filter radio buttons */}
              <li className="list-group-item">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="priceRange"
                    id="priceRange1"
                    value="range1"
                    checked={selectedPredefinedRange === "range1"}
                    onChange={handlePredefinedChange}
                  />
                  <label
                    className="form-check-label text-gray-600 text-sm font-medium"
                    htmlFor="priceRange1"
                  >
                    Under LKR 1000
                  </label>
                </div>
              </li>
              <li className="list-group-item">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="priceRange"
                    id="priceRange2"
                    value="range2"
                    checked={selectedPredefinedRange === "range2"}
                    onChange={handlePredefinedChange}
                  />
                  <label
                    className="form-check-label text-gray-600 text-sm font-medium"
                    htmlFor="priceRange2"
                  >
                    LKR 1000 - LKR 2500
                  </label>
                </div>
              </li>
              <li className="list-group-item">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="priceRange"
                    id="priceRange3"
                    value="range3"
                    checked={selectedPredefinedRange === "range3"}
                    onChange={handlePredefinedChange}
                  />
                  <label
                    className="form-check-label text-gray-600 text-sm font-medium"
                    htmlFor="priceRange3"
                  >
                    LKR 2500 - LKR 5000
                  </label>
                </div>
              </li>
              <li className="list-group-item">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="priceRange"
                    id="priceRange4"
                    value="range4"
                    checked={selectedPredefinedRange === "range4"}
                    onChange={handlePredefinedChange}
                  />
                  <label
                    className="form-check-label text-gray-600 text-sm font-medium"
                    htmlFor="priceRange4"
                  >
                    Over LKR 5000
                  </label>
                </div>
              </li>
              <li className="list-group-item">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="priceRange"
                    id="priceRangeCustom"
                    value="custom"
                    checked={selectedPredefinedRange === "custom"}
                    onChange={handlePredefinedChange}
                  />
                  <label
                    className="form-check-label text-gray-600 text-sm font-medium"
                    htmlFor="priceRangeCustom"
                  >
                    Custom price range:
                  </label>
                </div>
                {selectedPredefinedRange === "custom" && (
                  <div className="row mt-2 align-items-center">
                    <div className="col-5">
                      <input
                        type="number"
                        placeholder={`Min (${minPrice})`}
                        value={customMin}
                        onChange={handleCustomMinChange}
                        className="form-control"
                      />
                    </div>

                    <div className="col-5">
                      <input
                        type="number"
                        placeholder={`Max (${maxPrice})`}
                        value={customMax}
                        onChange={handleCustomMaxChange}
                        className="form-control"
                      />
                    </div>

                    <div className="col-2">
                      <button
                        className="btn btn-main btn-sm px-4 py-4"
                        onClick={applyCustomPriceFilter}
                        title="Apply custom price"
                        disabled={!isCustomValid}
                      >
                        <i className="bi bi-play-fill"></i>
                      </button>
                    </div>
                  </div>
                )}
                {(customMin !== "" || customMax !== "") && !isCustomValid && (
                  <small className="text-danger">
                    Please ensure Min price is less than Max price.
                  </small>
                )}
              </li>
            </ul>
          </div>
          <span className="mt-20 mb-3 text-md fw-md text-black">
            Categories
          </span>
          <ul
            className="list-none"
            ref={sidebarRef}
            style={{ overflowY: "auto" }}
          >
            {categories.map((category) => (
              <li key={category.id} className="py-2 border-b last:border-b-0">
                <button
                  className="w-full flex items-center justify-between text-gray-600 text-sm font-medium hover:text-blue-600 transition mt-4"
                  onClick={() => toggleCategory(category.id)}
                >
                  {category.name}
                  <span>{expandedCategories.has(category.id) ? "▲" : "▼"}</span>
                </button>
                {expandedCategories.has(category.id) &&
                  subCategories[category.id] && (
                    <ul className="pl-4 mt-4 space-y-2">
                      {subCategories[category.id].map((subCategory) => (
                        <li
                          key={subCategory.id}
                          className="flex items-center space-x-2 mt-4 checked-bigmall"
                        >
                          <input
                            type="checkbox"
                            id={subCategory.id}
                            checked={selectedSubCategories.has(subCategory.id)}
                            onChange={() =>
                              handleCheckboxChange(subCategory.id)
                            }
                            className="form-check-input"
                          />
                          <label
                            htmlFor={subCategory.id}
                            className="text-sm text-gray-600 cursor-pointer"
                          >
                            {subCategory.name}
                          </label>
                        </li>
                      ))}
                    </ul>
                  )}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="col-md-9" ref={productsRef}>
        {/* Sort by Dropdown on the right corner */}
        <div className="d-flex justify-content-end align-items-center mb-3 mt-24 gap-4">
          <label className="me-2">Sort by:</label>
          <select
            value={sortOption}
            onChange={handleSortChange}
            className="form-select w-auto"
          >
            <option value="priceLow">Price Low to High</option>
            <option value="priceHigh">Price High to Low</option>
            <option value="newArrivals">New Arrivals</option>
          </select>
          <button onClick={resetFilters} className="btn btn-main btn-sm">
            Reset Filters
          </button>
        </div>
        {loading && <LoadingComponent message="Loading products..." />}

        {!loading && products.length > 0 && (
          <ProductCards
            products={sortedProducts}
            currentPage={currentPage}
            totalPages={totalPages}
            showLoadmore={false}
            cardClass="col-xxl-3 col-lg-3 col-sm-4 col-6"
          />
        )}
      </div>
      {!loading && products.length > 0 && (
        <div className="container">
          <PaginateComponent
            totalPages={totalPages}
            currentPage={currentPage}
            handlePageClick={handlePageClick}
          />
        </div>
      )}
    </div>
  );
};

export default ProductListTwo;
